import BannerDescContainer from "@/components/container/bannerDescContainer";
import BoxContent from "@/components/container/boxContent";
import ImageDescContainer from "@/components/container/imageDescContainer";
import SingleImageContainer from "@/components/container/singleImageContainer";
import TextContainer from "@/components/container/textContainer";
import TextFloatImageContainer from "@/components/container/textFloatImageContainer";
import BottomCurves from "@/components/curves/bottomCurves";
import TopCurves from "@/components/curves/topCurves";
// import WorkList from "@/components/work/workList";
import WorkThumbnail from "@/components/work/workThumbnail";
import FloatingArrow from "@/components/uiDecor/floatingArrow";
import ContactButton from "@/components/layout/contactButton";
import SocialIcons from "@/components/layout/socialIcons";
import IntroContainer from "@/components/container/introContainer";

export {
    BannerDescContainer,
    BoxContent,
    ImageDescContainer,
    SingleImageContainer,
    TextContainer,
    TextFloatImageContainer,
    BottomCurves,
    TopCurves,
    // WorkList,
    WorkThumbnail,
    FloatingArrow,
    ContactButton,
    SocialIcons,
    IntroContainer,
};
